import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Popconfirm } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    supply_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        supply_name: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/mall_center/config/supply/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onConfirmDelete = (record: any) => {
        baseAxiosComplete.post('/mall_center/config/supply/delete', {
            id: record.supply_id

        }).then(res => {
            if (res.status === 0) {
                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 配置管理 -> 供应商管理 */}
        <BreadCrumb position={['商城中心', '供应商管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ width: '150px', marginRight: 5, marginBottom: 12 }} placeholder="供应商名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'supply_name') }} value={fetchOtherParams.supply_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to={"/supplier_add"}>添加</Link></Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="supply_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                <Column title="联系人" dataIndex="contact_man" key="contact_man" />
                <Column title="联系电话" dataIndex="contact_phone" key="contact_phone" />
                <Column title="所在地" dataIndex="location" key="location" />
                <Column title="具体地址" dataIndex="detail_addr" key="detail_addr" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="primary">
                                <Link to={"/supplier_edit/" + record.supply_id}>编辑</Link>
                            </Button>

                            <Popconfirm
                                title="确定删除?"
                                onConfirm={() => { onConfirmDelete(record) }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        </Space>
                    )}
                />
            </Table>
        </div>
    </div>)
}